import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_MONITORING_QUEUE_ENTRY_DETAILS } from "../types";
import {
  getMonitoringQueueEntryDetailsPending,
  getMonitoringQueueEntryDetailsFulfilled,
  getMonitoringQueueEntryDetailsRejected,
} from "../actions";

import { sendApiRequest, notifyWarning, notifyError } from "../../../actions";
import { MONITORING_QUEUE_ENTRY_DETAILS_MESSAGES } from "../constants/monitoringQueueEntryDetailsMessages";

const createPayload = (payload) => ({
  method: "get",
  url: "monitoringqueueentry/details",
  onSuccess: [
    getMonitoringQueueEntryDetailsFulfilled,
    (response) =>
      !response.data
        ? notifyWarning(MONITORING_QUEUE_ENTRY_DETAILS_MESSAGES.NOT_FOUND)
        : { type: "" },
  ],
  onError: [
    getMonitoringQueueEntryDetailsRejected,
    // TO DO: display error messages received from the server.
    () => notifyError("Failed to get Monitoring Queue Entry Details"),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getMonitoringQueueEntryDetailsEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_MONITORING_QUEUE_ENTRY_DETAILS.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) =>
      merge(
        of(getMonitoringQueueEntryDetailsPending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default getMonitoringQueueEntryDetailsEpic$;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/epics/getMonitoringQueueEntryDetailsEpic.js